import { Button, EmptyState } from "@crc/ui";

export function NotFound() {
  return <EmptyState icon="search" title="There is nothing at this address" text="The link may be old, or the record may be outside your account." actions={<Button variant="primary" to="/">Go home</Button>} />;
}
